import {
  Input,
  MultiSearchForm,
  useDebouncedSearch,
  useEffect,
  useRef,
  useState,
} from "@";
import { getUsers } from "../utils/api";
import { actionOptions, activityOptions, searchValues } from "../utils/options";

const MultiSearch = ({
  onSubmit,
  search,
  updateSearch,
  dataLength,
  onReset,
}) => {
  const [users, setUsers] = useState([]);
  const hasFetchedData = useRef(false);

  // Function to fetch users
  const fetchUsers = async () => {
    const { data } = await getUsers();
    const options = data?.data?.map((option) => ({
      value: option.id,
      label: option.displayName,
    }));
    setUsers(options);
  };

  useDebouncedSearch(onSubmit, search.values, searchValues);

  useEffect(() => {
    if (dataLength > 0 && !hasFetchedData.current) {
      fetchUsers();
      hasFetchedData.current = true;
    }
  }, [dataLength]);

  const handleInputChange = (field, value) => {
    updateSearch({
      values: { ...search.values, [field]: value },
    });
  };

  return (
    <MultiSearchForm
      show={search.show}
      onSubmit={onSubmit}
      reset={() => onReset()}
      className="multi-search-form xl:grid-cols-7"
    >
      {/* Dropdown for selecting user */}
      <Input
        star
        list={users}
        label="المستخدم"
        style="xl:col-span-2"
        type="select-searchable"
        value={users?.filter((c) => search.values.user == c.value)}
        change={(e) => handleInputChange("user", e ? e.value : null)}
      />

      {/* Dropdown for selecting activity */}
      <Input
        star
        label="النشاط"
        type="select"
        list={activityOptions}
        value={search.values.activity}
        change={(e) => handleInputChange("activity", e.target.value)}
      />

      {/* Dropdown for selecting action */}
      <Input
        star
        label="الحدث"
        type="select"
        list={actionOptions}
        value={search.values.action}
        change={(e) => handleInputChange("action", e.target.value)}
      />

      {/* Datepicker input */}
      <Input
        star
        showTimeSelect
        type="date-range"
        labelA="من تاريخ"
        labelB="الي تاريخ"
        style="xl:col-span-2"
        valueB={search.values.toDate}
        valueA={search.values.fromDate}
        changeA={(e) => handleInputChange("fromDate", e)}
        changeB={(e) => handleInputChange("toDate", e)}
      />
    </MultiSearchForm>
  );
};

export default MultiSearch;
